const React = require('react');
const PropTypes = require('prop-types');

const RAWizardCategory = function({ children }) {
    return <div className="robowizard-category">{children}</div>;
};

RAWizardCategory.propTypes = {
    isExpandable: PropTypes.bool,
    children: PropTypes.any,
    isHidden: PropTypes.bool,
};

RAWizardCategory.defaultProps = {
    isExpandable: true,
    isHidden: false,
};

module.exports = RAWizardCategory;
